import { AppBar, Toolbar, Typography, Menu, MenuItem, Alert, Box, IconButton, Avatar, ListItemIcon, ListItemText, Badge } from "@mui/material";
import JornadaService from "../../services/JornadaService";
import { IEstadoJornada } from "../../types/Jornada";
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FolderIcon from '@mui/icons-material/Folder';
import LogoutIcon from '@mui/icons-material/Logout';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ILog from "../../types/Log";
import LogService from "../../services/LogService";
import Utilities from "../../common/Utilities";
import ConfigUtils from "../../utils/Config";
import IActividad from "../../types/Actividad";
import * as constantes from "../../common/Constantes";
import { ISimpleUser } from "../config/Empleados";
import { onChange } from "../../utils/LogoEvents";
import IServicio from "../../types/Servicio";
import IMetodoPago from "../../types/MetodoPago";

import CalendarioIcon from '../icons/Calendario.svg?react';
import CalendarioActivoIcon from '../icons/CalendarioActivo.svg?react';
import PacientesIcon from '../icons/Pacientes.svg?react';
import PacientesActivoIcon from '../icons/PacientesActivo.svg?react';
import ClasesIcon from '../icons/Clases.svg?react';
import ClasesActivoIcon from '../icons/ClasesActivo.svg?react';
import FacturacionIcon from '../icons/Facturacion.svg?react';
import FacturacionActivoIcon from '../icons/FacturacionActivo.svg?react';


const NavIconButton = ({ to, matchPaths = [], icon, activeIcon, label, ariaLabel }: any) => {
  const active =
    location.pathname === to ||
    matchPaths.includes(location.pathname);
  const renderedIcon = active && activeIcon ? activeIcon : icon;
  return (
  <IconButton
    component={Link}
    to={to}
    aria-label={ariaLabel}
    sx={{
      mx: { xs: 0.5, md: 1.5 },
      display: "flex",
      flexDirection: "column",
      color: "white",
      transition: 'all 0.2s ease',
      '&:hover': {
        opacity: 0.85,
        transform: 'translateY(-1px)',
      },
    }}
  >
    {renderedIcon}
    <Typography
      sx={{
        fontSize: "10px",
        mt: 0.3,
        display: { xs: "none", md: "block" },
        letterSpacing: 0.3,
        opacity: 0.8,
      }}
    >
      {label}
    </Typography>
  </IconButton>
)};

const tamanoIconoJornada = { fontSize: 31, m: '-2.5px' };
// Punto de aviso en turquesa de marca (se ve bien sobre el fondo oscuro y no se confunde con el reloj ni con el coral del
// icono activo), con un borde del color de la barra para separarlo del reloj
const puntoJornadaSx = { '& .MuiBadge-badge': { backgroundColor: '#00CCB9', border: '2px solid #042930', minWidth: 12, height: 12, borderRadius: '50%' } };

const ToolbarIcons = ({ userRole, clinicLogo, user, empleado, actividades, servicios, metodosPago, verJornada, avisoJornada, handleMenu, constantes }: any) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      {/* Logo / Home */}
      <IconButton
        component={Link}
        to={constantes.R_HOME}
        aria-label="Home"
        sx={{
          // En móvil, con sesión iniciada, no se muestra: lleva a la Agenda igual que su icono y así cabe toda la barra
          display: { xs: user ? 'none' : 'inline-flex', md: 'inline-flex' },
          ml: { xs: 0, md: 3 },
          mr: { xs: 1, md: 4 },
        }}
      >
        {clinicLogo ? (
          <Box
            component="img"
            src={clinicLogo}
            alt="Logo clínica"
            sx={{
              width: { xs: 26, md: 36 },
              height: { xs: 26, md: 36 },
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          <HomeIcon fontSize="large" sx={{ color: "white" }} />
        )}
      </IconButton>

      {/* Navegación */}
      {user && (
        <>
          <NavIconButton
            to={constantes.R_AGENDA}
            matchPaths={["/"]}
            icon={<CalendarioIcon name="calendario" style={{ width: 26, height: 26 }} />}
            activeIcon={<CalendarioActivoIcon name="calendario" style={{ width: 26, height: 26 }} />}
            label="Calendario"
            ariaLabel="Agenda"
          />
          <NavIconButton
            to={constantes.R_PACIENTES}
            icon={<PacientesIcon name="pacientes" style={{ width: 26, height: 26 }} />}
            activeIcon={<PacientesActivoIcon name="calendario" style={{ width: 26, height: 26 }} />}
            label="Pacientes"
            ariaLabel="Pacientes"
          />
          {actividades.length > 0 && (
            <NavIconButton
              to={constantes.R_ACTIVIDADES}
              icon={<ClasesIcon name="clases" style={{ width: 26, height: 26 }} />}
              activeIcon={<ClasesActivoIcon name="calendario" style={{ width: 26, height: 26 }} />}
              label="Clases"
              ariaLabel="Clases"
            />
          )}
          {userRole !== constantes.ROLES.SANITARIO && servicios.length > 0 && metodosPago.length > 0 && (
            <NavIconButton
              to={constantes.R_FACTURACION}
              icon={<FacturacionIcon name="facturación" style={{ width: 26, height: 26 }} />}
              activeIcon={<FacturacionActivoIcon name="calendario" style={{ width: 26, height: 26 }} />}
              label="Facturación"
              ariaLabel="Facturación"
            />
          )}
          {verJornada && (
            <NavIconButton
              to={constantes.R_JORNADA}
              icon={<Badge variant="dot" invisible={!avisoJornada} sx={puntoJornadaSx}><ScheduleRoundedIcon sx={{ ...tamanoIconoJornada, color: 'white' }} /></Badge>}
              activeIcon={<Badge variant="dot" invisible={!avisoJornada} sx={puntoJornadaSx}><ScheduleRoundedIcon sx={{ ...tamanoIconoJornada, color: '#FF482E' }} /></Badge>}
              label="Jornada"
              ariaLabel="Registro de jornada"
            />
          )}

        <Box sx={{ flexGrow: 1 }} />

        {/* Avatar */}
        <Box>
          <IconButton aria-label="Configuración" onClick={handleMenu}>
            <Avatar
              sx={{
                bgcolor: empleado?.color,
                width: { xs: 32, md: 36 },
                height: { xs: 32, md: 36 },
                fontSize: "14px",
              }}
            >
              {empleado && empleado.firstName[0] + empleado.lastName[0]}
            </Avatar>
          </IconButton>
        </Box>
      </>
      )}
    </Box>
  );
};

const Navbar = () => {
    const history = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(ConfigUtils.getCurrentUser());
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [actividades, setActividades] = useState<Array<IActividad>>(ConfigUtils.getActividades());
    const [empleados, setEmpleados] = useState<Array<ISimpleUser>>(ConfigUtils.getEmpleados());
    const [clinicLogo, setClinicLogo] = useState<string | null>(ConfigUtils.getClinicLogo());
    const [servicios, setServicios] = useState<Array<IServicio>>(ConfigUtils.getServicios());
    const [metodosPago, setMetodosPago] = useState<Array<IMetodoPago>>(ConfigUtils.getMetodosPago());
    const [waConfig, setWaConfig] = useState<Boolean>(ConfigUtils.getWaConfig() ?? false);
    const [verJornada, setVerJornada] = useState<boolean>(ConfigUtils.getRegistroJornada()?.verSeccion === true);
    // Punto en el icono de Jornada si hay un recordatorio de fichar: se pide en cada cambio de pantalla y al fichar (evento
    // jornadaActualizada de Mi jornada), solo si la ayuda está activada
    const [avisoJornada, setAvisoJornada] = useState(false);
    const pedirAvisoJornada = () => {
        const registro = ConfigUtils.getRegistroJornada();
        // Sin sesión (al cerrarla) o sin la ayuda, sin punto
        if (!ConfigUtils.getCurrentUser() || !registro?.puedeFichar || !registro.ayudas?.badge) { setAvisoJornada(false); return; }
        JornadaService.getEstado()
            .then((response: { data: IEstadoJornada }) => setAvisoJornada(response.data.recordatorio !== null))
            .catch(() => setAvisoJornada(false));
    };
    useEffect(() => {
        if (ConfigUtils.getCurrentUser()) pedirAvisoJornada();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    useEffect(() => {
        const alActualizar = (e: Event) => setAvisoJornada((e as CustomEvent<boolean>).detail);
        window.addEventListener('jornadaActualizada', alActualizar);
        return () => window.removeEventListener('jornadaActualizada', alActualizar);
    }, []);

    const userRole: number = ConfigUtils.getUserRole();
    const userInternalID: number = ConfigUtils.getUserInternalId();
    const empleado: ISimpleUser | undefined = empleados.find(e => e.internalID === userInternalID);

    const exit = () => {
        setUser(null);
        setAnchorEl(null);
        Utilities.logOut();
        history(constantes.R_HOME);
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
      const publicRoutes = [
        constantes.R_RESETPASS,
        constantes.R_CREATEPASS
      ];
      const params = new URLSearchParams(location.search);
      const isRegister = params.has("register");

      if (publicRoutes.includes(location.pathname) || isRegister) return;

      const onLocationChange = () => {
          setUser(ConfigUtils.getCurrentUser());
          setActividades(ConfigUtils.getActividades());
          setEmpleados(ConfigUtils.getEmpleados());
          setClinicLogo(ConfigUtils.getClinicLogo());
          setServicios(ConfigUtils.getServicios());
          setMetodosPago(ConfigUtils.getMetodosPago());
          setWaConfig(ConfigUtils.getWaConfig() ?? false);
          setVerJornada(ConfigUtils.getRegistroJornada()?.verSeccion === true);
          // Al entrar y al salir se vuelve a «/», sin cambio de ruta: el punto de Jornada se pide aquí
          pedirAvisoJornada();
      };
      window.addEventListener('popstate', onLocationChange);
      
      if (!user) {
          Utilities.logOut();
          history(constantes.R_HOME);
      }

      // Un solo oyente: el efecto se repite en cada cambio de pantalla
      return () => window.removeEventListener('popstate', onLocationChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, user, location.pathname]);

    useEffect(() => {
        const unsubscribe = onChange((newLogo) => {
            setClinicLogo(newLogo);
        });
        return unsubscribe;
    }, []);

    try {
        return (
            <Box sx={{ flexGrow: 1 }}>
              <AppBar position="static" sx={{ backgroundColor: '#042930', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <Toolbar>
                  <ToolbarIcons
                    userRole={userRole}
                    clinicLogo={clinicLogo}
                    user={user}
                    empleado={empleado}
                    actividades={actividades}
                    servicios={servicios}
                    metodosPago={metodosPago}
                    verJornada={verJornada}
                    avisoJornada={avisoJornada}
                    handleMenu={handleMenu}
                    constantes={constantes}
                  />
                  <Menu
                    id="menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {userRole === constantes.ROLES.ADMINISTRADOR && (
                      <Link to={constantes.R_CONFIG} style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}>
                        <MenuItem divider onClick={handleClose}>
                          <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
                          <ListItemText>Configuración</ListItemText>
                        </MenuItem>
                      </Link>
                    )}
                    {userRole === constantes.ROLES.ADMINISTRADOR && (
                      <Link to={constantes.R_SUSCRIPCION} style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}>
                        <MenuItem divider onClick={handleClose}>
                          <ListItemIcon><CreditCardIcon fontSize="small" /></ListItemIcon>
                          <ListItemText>Suscripción</ListItemText>
                        </MenuItem>
                      </Link>
                    )}
                    {userRole === constantes.ROLES.ADMINISTRADOR && waConfig && (
                      <Link to={constantes.R_WHATSAPP} style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}>
                        <MenuItem divider onClick={handleClose}>
                          <ListItemIcon><WhatsAppIcon fontSize="small" /></ListItemIcon>
                          <ListItemText>WhatsApp</ListItemText>
                        </MenuItem>
                      </Link>
                    )}
                    <MenuItem divider onClick={() => window.open("https://drive.google.com/drive/folders/1zreAjmF7qnqQMYc3XHCypxieQ09tpvrp")}>
                      <ListItemIcon><FolderIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Manuales</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={exit}>
                      <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Salir</ListItemText>
                    </MenuItem>
                  </Menu>
                </Toolbar>
              </AppBar>
            </Box>
        );
    } catch (e: any) {
        const error: ILog = { method: 'Navbar.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }
    
};

export default Navbar;